import { ExtractMenuItemProvider } from './extract/ExtractNotificationMenuItemProvider';
import { FlowNotificationMenuItemProvider } from './flow/FlowNotificationMenuItemProvider';
import { IUserNotificationMenuItemProvider } from './IUserNotificationMenuItemProvider';
import { UserNotificationMenuItemDefaultProvider } from './UserNotificationMenuItemDefaultProvider';
import { UserNotificationActions } from '../redux/UserNotificationActions';
import { UserNotificationType } from '@tableau/user-notifications-client-core';

export function NotificationMenuitemProviders(userNotificationActions: UserNotificationActions): _.Dictionary<IUserNotificationMenuItemProvider<any>> {
    // this is used to register feature content providers
    return {
        [UserNotificationType.Commenting]: new UserNotificationMenuItemDefaultProvider(userNotificationActions),
        [UserNotificationType.CreateExtractFailure]: new ExtractMenuItemProvider(userNotificationActions),
        [UserNotificationType.FlowCompleted]: new FlowNotificationMenuItemProvider(userNotificationActions),
        [UserNotificationType.RefreshExtractFailure]: new ExtractMenuItemProvider(userNotificationActions),
        [UserNotificationType.RefreshExtractSuspension]: new ExtractMenuItemProvider(userNotificationActions),
        [UserNotificationType.Sharing]: new UserNotificationMenuItemDefaultProvider(userNotificationActions),
    };
}